import React, { useState, useEffect } from "react";
import axios from "axios";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ReactSwitchreview from 'react-switch'
import ReactSwitchsupport from 'react-switch'
import ReactPlayer from 'react-player'
import Modal from '../Modal/Modal';
import { isPro, getNoticeData } from '../../Helpers';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css'
import NoticeModal from '../NoticeModal/NoticeModal';
import "./wpwidgets.scss"

const Wpwidgets = ({ noticeSettings }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [passview, setPassview] = useState(false);
    const [credentials, setCredentials] = useState([]);
    const [getGlobalURL, setGetGlobalURL] = useState(false);
    const proData = isPro();

    const allConditionsMet = proData;
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        type: 'confirmation',
        title: '',
        message: '',
        onConfirm: () => { },
        confirmText: 'Confirm',
        declineText: 'Cancel'
    });
    const closeModal = () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
    };

    // Extract the last part of the URL as the site identifier
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const indexOfAdmin = pathParts.indexOf('wp-admin');
    const siteIdentifier = indexOfAdmin !== -1 ? pathParts.slice(indexOfAdmin - 1, indexOfAdmin).pop() : pathParts.slice(-1).pop();
    // Use the site identifier to create a unique localStorage key
    const localStorageKey = `wpnts_widget_settings_${siteIdentifier}`;
    //END ------------------


    const handleViewpass = () => {
        passview === true ? setPassview(false) : setPassview(true)
    }

    useEffect(() => {
        getWebhook();
    }, []);

    function getWebhook() {
        const wpnts_widget_settings = getNoticeData().wpntswebhook_widget_settings || {
            webhook: '',
            delete_widget: false,
            save_widget: false,

        };

        const formData = JSON.parse(localStorage.getItem(localStorageKey) || JSON.stringify(wpnts_widget_settings));
        setCredentials(formData);
    }


    const [wpntswebhook_widget_settings, setWebhook] = useState({
        webhook: credentials.webhook,
        delete_widget: credentials.delete_widget,
        save_widget: credentials.save_widget,

    });

    const handleGetGlobalURLChange = () => {
        const globalSlack = noticeSettings.wpnts_global_api_settings.global_webhook ?? '';
        setWebhook(prev => ({ ...prev, webhook: globalSlack }))
    };

    const handleChange = e => {
        setWebhook(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }



    /**
     * 
     * @param {HtAccess} e 
     * @returns 
     */
    const handleDeletewidget = e => {
        setWebhook(prev => ({ ...prev, delete_widget: e }));
    }

    const handleSavewidget = e => {
        setWebhook(prev => ({ ...prev, save_widget: e }));
    }


    useEffect(() => {
        setWebhook({
            webhook: credentials.webhook,
            delete_widget: credentials.delete_widget,
            save_widget: credentials.save_widget,
        });
    }, [credentials]);


    const handleSave = async e => {
        e.preventDefault()
        localStorage.setItem(localStorageKey, JSON.stringify(wpntswebhook_widget_settings));

        //
        /**
         * Add new plugin list name 
         * 
         */
        const url = `${appLocalizer.wpntsUrl}/wpnts/v1/slack_webhook_widget_settings`;
        try {
            const res = await axios.post(url, {
                wpntswebhook_widget_settings

            }, {
                headers: {
                    'content-type': 'application/json',
                    'X-WP-NONCE': appLocalizer.nonce
                }
            }).then(function (res) {
                // console.log(wpntswebhook_widget_settings)
            });

        } catch (err) {
            console.log(err);
        }


        setModalConfig({
            isOpen: true,
            type: 'toast',
            title: 'success',
            message: 'Webhook configure successfully',
            position: 'top-right'
        });
        setTimeout(closeModal, 3000);

    }
    return (
        <div className="acb_widgets" id='acb_widgets'>
            <div className="acb_left">
                <h3>Advance widgets settings panel
                    <a href="https://www.youtube.com/playlist?list=PL4m92NgWQaq5ttBH9gSYUX1r4c6rtgLg9" target="_blank"><PlayCircleIcon className='PlayCircleIcon' /></a>
                </h3>
                <br />


                <div className="wpnts-switch-sitessecurityissues">
                    {/* <p className="NEW_TAG">New</p> */}
                    <div className={`media-feature`}>
                        <ReactSwitchsupport uncheckedIcon checkedIcon className="sitessecurity-supportSwitch-3" name="wpnts-switch-p-deactivation" id="save_widget" onChange={handleSavewidget} checked={wpntswebhook_widget_settings.save_widget} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                        <label htmlFor="save_widget">Adding/updating widgets event</label>
                        <Tippy content="You will be notified as soon as any widgets added/updated from your site.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>

                    </div>
                </div>


                <div className="wpnts-switch-sitessecurityissues">
                    {/* {!allConditionsMet ? <p className="PRO_TAG">PRO</p> : ''} */}
                    {/* <p className="NEW_TAG">New</p> */}
                    <div className={`media-feature`}>
                        <ReactSwitchsupport uncheckedIcon checkedIcon className="sitessecurity-supportSwitch-3" name="wpnts-switch-p-deactivation" id="delete_widget" onChange={handleDeletewidget} checked={wpntswebhook_widget_settings.delete_widget} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                        <label htmlFor="delete_widget">Widget deletion event</label>
                        <Tippy content="You will be notified as soon as any widgets deleted from your site.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>

                    </div>
                </div>





            </div>
            <div className="acb_right">

                {/* <form action="" id="wpntswebhook_widget_settings"> */}
                <form action="" id="wpnts_widget_settings">
                    <div className="formInput">
                        <label htmlFor="webhook">Webhook URL</label>
                        <div className="wpnts-setting">
                            <div className="passimg" onClick={handleViewpass}>
                                {passview === false ? <VisibilityOffIcon className='passVisibility' /> : <VisibilityIcon className='passVisibility' />}
                            </div>
                            <input type={passview === true ? "text" : "password"} placeholder="add webhook " name="webhook" required onChange={handleChange} value={wpntswebhook_widget_settings.webhook} />
                        </div>
                    </div>

                    <div className="getGlobalURLCheckbox">
                        <input
                            type="checkbox"
                            id="getGlobalURL"
                            checked={getGlobalURL}
                            onChange={handleGetGlobalURLChange}
                        />
                        <label htmlFor="getGlobalURL">Click to get slack global webhook</label>
                    </div>


                    <button className="save-webhook" onClick={handleSave}>SAVE</button>
                </form>

            </div>

            <NoticeModal
                isOpen={modalConfig.isOpen}
                onClose={closeModal}
                onConfirm={modalConfig.onConfirm}
                onDecline={closeModal}
                type={modalConfig.type}
                title={modalConfig.title}
                message={modalConfig.message}
                confirmText={modalConfig.confirmText}
                declineText={modalConfig.declineText}
                position={modalConfig.position || 'center'}
                autoClose={modalConfig.type === 'toast'}
                autoCloseTime={3000}
            />
            {modalOpen && <><div class="wcs_popup_overlay"></div> <Modal setOpenModal={setModalOpen} /> </>}
        </div >
    )
}

export default Wpwidgets
